.body {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  margin: 0 auto;
  max-width: 1440px;
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-16);
  width: 100%;
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.sectionHeader {
  border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
  padding: var(--pgm-sys-spacing-2) 0;
}

.sectionName {
  color: var(--pgm-sys-color-primary);
  margin: 0;
  text-transform: uppercase;
}

.explanation {
  align-items: center;
  color: var(--pgm-sys-color-on-surface);
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-1);
  margin: 0;
}
